import { objectOf } from "@altostra/type-validations";

export const isCompaniesCompanyIdNotificationPreferencesBulkAddResult = objectOf({});
